import axios from 'axios';
import Swiper, { Navigation, Controller } from 'swiper';
import 'swiper/css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
window.gsap = gsap;
gsap.registerPlugin(ScrollTrigger);

const teamListSliderTotal = document.querySelectorAll('.team-leaders-list__slider .swiper-slide').length.toString().padStart(2, '0');
const teamListSliderThumbs = new Swiper('.team-leaders-list__slider-thumbs .swiper', {
	slidesPerView: 1,
	spaceBetween: 25,
	loop: true,
	loopAdditionalSlides: 3,
	breakpoints: {
		480: {
			spaceBetween: 35,
		},
	}
});
const teamListSlider = new Swiper('.team-leaders-list__slider .swiper', {
	modules: [Navigation, Controller],
	slidesPerView: 1,
	spaceBetween: 25,
	loop: true,
	loopAdditionalSlides: 3,
	touchReleaseOnEdges: true,
	navigation: {
		nextEl: '.team-leaders-list__slider-nav .swiper__next',
		prevEl: '.team-leaders-list__slider-nav .swiper__prev',
	},
	controller: {
		control: teamListSliderThumbs,
	},
	breakpoints: {
		480: {
			spaceBetween: 35,
		},
	}
});

const teamListSliderCount = document.querySelector('.team-leaders-list__slider-count');
teamListSliderCount.querySelector('span:first-child').textContent = '01';
teamListSliderCount.querySelector('span:last-child').textContent = teamListSliderTotal;
teamListSlider.on('slideChange', function () {
	let count = teamListSlider.realIndex + 1;
	teamListSliderCount.querySelector('span:first-child').textContent = count.toString().padStart(2, '0');
});


// filter dropdown
const filterDropdown = document.querySelectorAll('.filter-dropdown');
const centurionsFilter = document.querySelector('#centurions-filter');
let centurionsPage = 1;

if (filterDropdown) {
	filterDropdown.forEach((filter) => {
		let currentFilter = filter.querySelector('.filter-dropdown__current');
		let currentFilterSlug = currentFilter.getAttribute('data-filter');
		let filterItems = filter.querySelectorAll('.menu-item');
		// add selected class
		filter.querySelector(`.menu-item[data-filter="${currentFilterSlug}"]`).classList.add('selected');
		// open menu and close menu if click outside filter el
		currentFilter.addEventListener('click', (event) => {
			filter.classList.add('active');
		});
		let filterListener = function(event) {
			closeFilterDropdown(event, filter, filterListener);
		}
		document.addEventListener('click', filterListener, true);
		// update dropdown with new selected filter and close menu
		filterItems.forEach((item) => {
			item.addEventListener('click', (event) => {
				let newFilterSlug = item.getAttribute('data-filter');
				let newFilterName = item.textContent;
				currentFilter.setAttribute('data-filter', newFilterSlug);
				currentFilter.querySelector('span').textContent = newFilterName;
				filter.querySelector('.menu-item.selected').classList.remove('selected');
				item.classList.add('selected');
				filter.classList.remove('active');
				// filter centurions
				document.querySelector(`input[name="${filter.getAttribute('data-name')}"]`).value = newFilterSlug;
				centurionsPage = 1;
				centurionsFilterSubmit(1, false, filter);
			});
		});
	});
}

// close filter dropdown when clicking outside
function closeFilterDropdown(event, filter, filterListener) {
	let targetEl = event.target;
	do {
		if (targetEl == filter) {
			// console.log('Clicked inside!');
			return;
		}
		// Go up the DOM
		targetEl = targetEl.parentNode;
	}
	while (targetEl);
	// console.log('Clicked outside!');
	filter.classList.remove('active');
	// document.removeEventListener('click', filterListener, true);
}

// load more centurions
let loadmore = document.querySelector('.load-more-posts');
if (loadmore) {
	loadmore.addEventListener('click', (event) => {
		event.preventDefault();
		centurionsPage++;
		centurionsFilterSubmit(centurionsPage, true);
	});
}

// ajax to retrieve filtered news posts
let loader = document.createElement('div');
loader.className = 'lds-ellipsis';
loader.appendChild(document.createElement('div'));
loader.appendChild(document.createElement('div'));
loader.appendChild(document.createElement('div'));
loader.appendChild(document.createElement('div'));	
function centurionsFilterSubmit(paged = 1, loadmore_posts = false, filter = false) {
	let formData = new FormData(centurionsFilter);
	let ajaxEl = centurionsFilter;
	let ajaxLoaderEl = centurionsFilter.querySelector('.filter-dropdown__current');
	if (filter) {
		ajaxLoaderEl = filter.querySelector('.filter-dropdown__current');
	}
	if (loadmore_posts) {
		ajaxEl = loadmore;
		ajaxLoaderEl = loadmore;
	}
	ajaxEl.classList.add('ajaxing');
	ajaxLoaderEl.append(loader);
	formData.append('action', 'centurions_filter');
	formData.append('paged', paged);
	// form ajax
	axios.post( ajaxurl, formData )
	.then( response => {
		// console.log(response);
		// remove ajax and loader
		ajaxEl.classList.remove('ajaxing');
		loader.remove();
		if (loadmore) {
			if (response.data.last_page || response.data.no_posts) {
				loadmore.remove();
			} else {
				document.querySelector('.pagination').append(loadmore);
			}
		}
		if (loadmore_posts) {
			document.querySelector('.team-list__grid').insertAdjacentHTML('beforeend', response.data.posts);
		} else {
			document.querySelector('.team-list__grid').innerHTML = response.data.posts;
		}
	})
	.catch( error => {
		console.log(error);
		ajaxEl.classList.remove('ajaxing');
	})
}

// animation for shapes on the team leadership slider
const centurionShapesAnim = document.querySelector('.team-leaders-list__slider');
if (centurionShapesAnim) {
	// add shapes to card
	let circlePrimary = document.createElement('div'),
	smCircleTertiary = document.createElement('div');
	circlePrimary.className = 'anim-circle-primary';
	smCircleTertiary.className = 'anim-sm-circle-tertiary anim-sm-circle-tertiary--overlap';
	centurionShapesAnim.appendChild(circlePrimary);
	centurionShapesAnim.appendChild(smCircleTertiary);
	// animate shapes on scroll
	gsap.timeline({
		scrollTrigger: {
			trigger: centurionShapesAnim,
			start: 'top 65%',
			end: '100% 65%',
			toggleActions: 'play none none reverse',
			invalidateOnRefresh: true,
			// markers: true,
		},
	})
	.fromTo(smCircleTertiary, {scale: 0}, {scale: 1, ease: 'power2.out', duration: 1.5})
	.fromTo(circlePrimary, {scale: 0}, {scale: 1, ease: 'power2.out', duration: 1.5}, '<=0.1');
}
